import type { FilesApi } from '@odo/shared-ui';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { createCbctProcessingApi } from '../services/cbctProcessingApi';
import { filesApi } from '../services/filesApi';
import { withAvatarRefreshOnDelete } from './profilePictureQueries';
import { useSetProfilePicture } from './useSetProfilePicture';

// Avatar writes go through app-side code so the toast and avatar cache refresh stay out
// of shared-ui; FilesPanel only tracks pending state.
export function usePatientFilesApi(patientId: string): FilesApi {
    const queryClient = useQueryClient();
    const { mutateAsync: setProfilePicture } = useSetProfilePicture();

    return useMemo<FilesApi>(
        () => ({
            ...filesApi,
            deleteFile: withAvatarRefreshOnDelete(queryClient, filesApi.deleteFile),
            cbctProcessing: createCbctProcessingApi(patientId),
            setProfilePicture: async (targetPatientId, patientFileId) => {
                await setProfilePicture({ patientId: targetPatientId, patientFileId });
            }
        }),
        [patientId, queryClient, setProfilePicture]
    );
}
